import React from 'react';

interface LumiLogoRoundProps {
  className?: string;
  size?: number;
}

export function LumiLogoRound({ className = '', size = 32 }: LumiLogoRoundProps) {
  return (
    <div 
      className={`relative ${className}`}
      style={{ width: size, height: size }}
    >
      {/* Round background with Lumi yellow */}
      <div className="absolute inset-0 bg-[#FFD700] rounded-full overflow-hidden">
        {/* Lumi text centered in the circle */}
        <div className="w-full h-full flex items-center justify-center">
          <span 
            className="lumi-logo-text text-black select-none"
            style={ {
              ['--lumi-logo-fs' as any]: `${size * 0.36}px`
            } as React.CSSProperties }
          >
            lumi
          </span>
        </div>
      </div>
    </div>
  );
}

// SVG version for better scalability
export function LumiLogoRoundSVG({ className = '', size = 32 }: LumiLogoRoundProps) {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 100 100" 
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Circle background */}
      <circle cx="50" cy="50" r="50" fill="#FFD700" />
      
      {/* Lumi text */}
      <text 
        x="50" 
        y="56" 
        className="lumi-logo-svg-text"
        fill="black"
        textAnchor="middle"
        dominantBaseline="middle"
      >
        lumi
      </text>
    </svg>
  );
}